const ACTIVITY_EVENTS = [
  'mousemove',
  'mousedown',
  'keydown',
  'scroll',
  'touchstart',
  'wheel',
] as const;

export const createInactivityWatcher = ({
  timeoutMs,
  onTimeout,
  onActivity,
}: {
  timeoutMs: number;
  onTimeout: () => void;
  onActivity?: () => void;
}) => {
  let timer: ReturnType<typeof setTimeout>;

  const reset = () => {
    clearTimeout(timer);
    timer = setTimeout(onTimeout, timeoutMs);
  };

  const handleActivity = () => {
    reset();
    onActivity?.();
  };

  ACTIVITY_EVENTS.forEach((event) =>
    window.addEventListener(event, handleActivity, { passive: true }),
  );

  reset();

  return {
    reset,
    cleanup: () => {
      clearTimeout(timer);
      ACTIVITY_EVENTS.forEach((event) => window.removeEventListener(event, handleActivity));
    },
  };
};
